import { render } from "./FrontProject.vue?vue&type=template&id=356cfcee&scoped=true"
import script from "./FrontProject.vue?vue&type=script&lang=js"
export * from "./FrontProject.vue?vue&type=script&lang=js"

import "./FrontProject.vue?vue&type=style&index=0&id=356cfcee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-356cfcee"]])

export default __exports__